export default __webpack_public_path__ + "static/media/a4size3.2bdc990e.jpg";